import gql from "graphql-tag";

const CONTACT_EMAIL = gql`
mutation contactEmail($input: CreateContactInput!){
    contactEmail(input: $input)
  }
`;

export { CONTACT_EMAIL }